/* istanbul ignore file */
import type { ComponentProps } from 'react';

import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { CalloutHeading as CalloutHeadingSunrise } from './CalloutHeading';
import { CalloutHeading as CalloutHeadingLegacy } from './CalloutHeadingLegacy';

export const CalloutHeading = (props: ComponentProps<typeof CalloutHeadingLegacy>) => {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (isSunriseThemeEnabled) return <CalloutHeadingSunrise {...props} />;

	return <CalloutHeadingLegacy {...props} />;
};
